import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import { FaUserAlt, FaSuitcase, FaUmbrellaBeach } from "react-icons/fa";
import { RiDashboardFill, RiChat3Line } from "react-icons/ri";
import { LiaProjectDiagramSolid } from "react-icons/lia";
import { FaGear } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const SuperAdminSideBar = ({ collapsed, setLabel1, setLabel2 }) => {
  const { t } = useTranslation("dashboard");
  const menuItems = [
    {
      key: "Dashboard",
      icon: <RiDashboardFill />,
      label: <Link to="/admin">{t("Dashboard")}</Link>
    },
    {
      key: "Chat",
      icon: <RiChat3Line />,
      label: <Link to="/chats">{t("Chat")}</Link>,
      permission: "Chat"
    },
    {
      key: "Subadmins",
      icon: <LiaProjectDiagramSolid />,
      label: <Link to="/admin/subadmins">{t("Subadmins")}</Link>,
      permission: "Subadmins"
    },
    {
      key: "Service-providers",
      icon: <FaUmbrellaBeach />,
      label: <Link to="/admin/users-list">{t("Service-providers")}</Link>,
      permission: "Service-providers"
    },
    {
      key: "Projects",
      icon: <FaSuitcase />,
      label: <Link to="/admin/projects">{t("Projects")}</Link>,
      permission: "Projects"
    },
    {
      key: "Profile",
      icon: <FaUserAlt />,
      label: <Link to="/admin/profile">{t("Profile")}</Link>,
      permission: "Admin"
    },
    {
      // Distinct from the child's key: a shared key highlights both and breaks open state.
      key: "SettingsGroup",
      icon: <FaGear />,
      label: t("Settings"),
      permission: "Settings",
      children: [
        {
          key: "Settings",
          icon: <FaGear />,
          label: <Link to="/admin/roles">{t("Settings")}</Link>
        }
      ]
    }
  ];

  // Follow the route, so the highlight is right after a reload or a link from elsewhere.
  const { pathname } = useLocation();
  const ROUTE_KEYS = [
    ["/chats", "Chat"],
    ["/chat", "Chat"],
    ["/admin/subadmins", "Subadmins"],
    ["/admin/users-list", "Service-providers"],
    ["/admin/projects", "Projects"],
    ["/admin/profile", "Profile"],
    ["/admin/roles", "Settings"]
  ];
  const selectedKey = ROUTE_KEYS.find(([path]) => pathname.startsWith(path))?.[1] || "Dashboard";

  const selectkeysmenu = e => {
    setLabel1("great");
    setLabel2(e.keyPath[0]);
  };

  return (
    <Menu
      className="sidersidenav"
      selectedKeys={[selectedKey]}
      defaultOpenKeys={selectedKey === "Settings" ? ["SettingsGroup"] : []}
      mode="inline"
      theme="light"
      inlineCollapsed={collapsed}
      items={menuItems}
      style={{ height: "100%" }}
      onSelect={selectkeysmenu}
    />
  );
};

export default SuperAdminSideBar;
